module.exports = __webpack_public_path__ + "static/media/agritech_icon.cf10952c.svg";